
import { PropertyImageManager } from "../PropertyImageManager";

interface PropertyImagesTabProps {
  propertyId: string;
  currentImages: any[];
  onImagesUpdated: () => void;
}

export const PropertyImagesTab = ({
  propertyId,
  currentImages,
  onImagesUpdated
}: PropertyImagesTabProps) => {
  return (
    <PropertyImageManager
      propertyId={propertyId}
      currentImages={currentImages}
      onImagesUpdated={onImagesUpdated}
    />
  );
};
